import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import MultiFieldItem from '../../../features/components/Form/MultiFieldItem'

import { findNestedObj } from '../../../helpers/arrays'

import useStyles from './styles'

const MultiLevelSelectedValues = ({
  name,
  values,
  options,
  optionsState,
  onOptionDeselect,
  CustomMultiFieldItem,
  setFullOptionObject,
  selectedOptionsWrapperClassName
}) => {
  const classes = useStyles()

  const selectedOptionsData = values.map(option => {
    if (setFullOptionObject) {
      return findNestedObj(options, 'id', option.id)
    } else {
      return findNestedObj(options, 'id', option)
    }
  })

  const renderValueItemContent = useCallback(
    (option, index) => {
      const optionParentId = option && option.parent

      // if parent is selected > skip rendering children options
      const isParentSelected = optionParentId && optionsState[optionParentId]?.isChecked

      if (!option || !option.name || isParentSelected) {
        return null
      }

      if (CustomMultiFieldItem) {
        return React.cloneElement(CustomMultiFieldItem, {
          name,
          index,
          value: option,
          key: option.id,
          label: option.name,
          deleteHandler: onOptionDeselect
        })
      } else {
        return (
          <MultiFieldItem
            key={option.id}
            value={option}
            label={option.name}
            deleteHandler={onOptionDeselect}
            className={classes.selectedItem}
          />
        )
      }
    },
    [classes.selectedItem, onOptionDeselect, optionsState, CustomMultiFieldItem, name]
  )

  if (!values.length || !options.length) {
    return null
  }

  return (
    <div className={classnames(classes.selectedOptionsWrapper, selectedOptionsWrapperClassName)}>
      {selectedOptionsData.map((option, index) => renderValueItemContent(option, index))}
    </div>
  )
}

MultiLevelSelectedValues.propTypes = {
  values: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  optionsState: PropTypes.object.isRequired,
  onOptionDeselect: PropTypes.func.isRequired,
  selectedOptionsWrapperClassName: PropTypes.string
}

export default MultiLevelSelectedValues
